module.exports = __webpack_public_path__ + "static/img/s-vivo-5.14a027b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/clac/img/s-vivo-5.png
// module id = nL1z
// module chunks = 1